import React from 'react';
import styles from '../WildHeartForm.module.scss';

const SectionSubTitle = ({ label }) => {
  return <p className={styles.formSubtitle}>{label}</p>;
};

export default SectionSubTitle;
